import { render, staticRenderFns } from "./IdeaItem.vue?vue&type=template&id=0958e334&scoped=true"
import script from "./IdeaItem.vue?vue&type=script&lang=js"
export * from "./IdeaItem.vue?vue&type=script&lang=js"
import style0 from "./IdeaItem.vue?vue&type=style&index=0&id=0958e334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0958e334",
  null
  
)

export default component.exports